export default __webpack_public_path__ + "images/logo.103e5ff9d5ebff220a4867cb07fb99cb.png";